import React from 'react';
import { WarningTriangle } from '../../../assets/common_svgs';

const QuickOrdersError = ({ error, cn }) => (
  <div className={`quick-orders__error tc-cef-red fl ai-c fs-14 pt-8 ${cn}`}>
    <WarningTriangle
      cn="quick-orders__error--icon"
      fillColor="#d41f3a"
      height="17"
      width="17"
    />
    <p className="no-mb ml-3">{error}</p>
  </div>
);

export default QuickOrdersError;
